import BaseRoute from "../../../../../../lib/itn-ui-kit/route/base-route";
import { service } from "../../../../../../lib/itn-ui-kit/services/service-container.js";
import { loadDocumentData } from "../../../../../components/modules/documentsListView/utils/document-loader-helpers";

import Template from "./template";

export default class FinanceCasesDetailDocumentsRoute extends BaseRoute {
  @service("repositories/document-repository") documentRepository;
  @service("repositories/case-repository") caseRepository;

  element = (<Template />);
  revalidateOnParams = ["id"];

  async loader({ params, request }) {
    const { id } = params;
    const url = new URL(request.url);
    const searchParams = Object.fromEntries(url.searchParams.entries());

    return await loadDocumentData({
      documentRepository: this.documentRepository,
      caseRepository: this.caseRepository,
      caseId: id,
      searchParams,
    });
  }
}
